import React, { useState, useEffect, useRef } from "react";
import { Row, Button, Col, Checkbox, Card, Input, Space, Typography, Drawer, Form } from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import RetailModal from "../Retail/RetailModals";
import db from "../../../database";
import Calender from "../../../assets/images/calender.svg";
import Close from "../../../assets/images/close-x.svg";
import CancelArrow from "../../../assets/images/cancelArrow.svg";
import { getMultilingualText } from "../../../utils/getMultilingualText";
import userIcon from "../../../assets/images/userId.svg";
import CashGif from "../../../assets/images/cashGif.gif";
import useAuthStore from "../../../stores/useAuthStore";
const CashManagement = (props) => {
  const { Text, Title } = Typography;
  const {
    setAddCashFlag,
    setCashAddInFlag,
    handleCahInOut,
    cashAddInFlag,
    addCashFlag,
    posConfig,
    onChangeCheckbox,
    width,
    cashManagementForm,
    cashIn,
    pettyCashIn,
    userPreferences,
  } = props;
  const currentDateTime = useState(dayjs(new Date()).format(userPreferences.dateFormat));
  const [cashInData, setCashInData] = useState([]);
  const userData = useAuthStore.getState().userData;

  const handleCashManagement = (value) => {
    let formData = cashManagementForm.getFieldsValue(true);

    if (formData.amount === "" && value === "x") {
      cashManagementForm.setFieldsValue({
        amount: "",
      });
    } else if (value === "x") {
      cashManagementForm.setFieldsValue({
        amount: `${formData.amount.toString().substring(0, formData.amount.toString().length - 1)}`,
      });
    } else {
      cashManagementForm.setFieldsValue({
        amount: `${formData.amount ? formData.amount : ""}${value}`,
      });
    }
  };

  const handleCashInNote = (value) => {
    cashManagementForm.setFieldsValue({
      note: value,
    });
  };

  useEffect(() => {
    db.cashInCashOut.toArray().then((res) => {
      setCashInData(res);
    });
  }, [cashInData]);
  const handleClear = () => {
    cashManagementForm.setFieldsValue({ amount: "" });
  };

  const actionButtons = (
    <Space direction="horizontal" style={{ fontSize: "1vw" }}>
      <Button
        onClick={() => {
          setAddCashFlag(true);
          setCashAddInFlag(true);
        }}
        style={{
          height: "6vh",
          backgroundColor: "#2F3856",
          color: "#fff",
          minWidth: "11vw",
          borderRadius: "10px",
          fontSize: "1em",
          fontWeight: "500",
        }}
      >
        {getMultilingualText("Remove Cash")}
      </Button>
      <Button
        onClick={() => {
          setAddCashFlag(true);
          setCashAddInFlag(false);
        }}
        style={{
          height: "6vh",
          backgroundColor: "#2F3856",
          color: "#fff",
          minWidth: "11vw",
          borderRadius: "10px",
          fontSize: "1em",
          fontWeight: "500",
        }}
      >
        {getMultilingualText("Add Cash")}
      </Button>
    </Space>
  );

  return (
    <div style={{ padding: "2vh 1.5vw", display: "flex", flexDirection: "column", height: "100vh" }}>
      <Row style={{ alignItems: "center", marginBottom: "2vh" }}>
        <Col span={12}>
          <span style={{ fontSize: "1.5em", fontWeight: "600", color: "#0F0718" }}>
            {getMultilingualText("Cash Management")}
          </span>
        </Col>
        <Col span={12} style={{ textAlign: "right", fontSize: "1vw" }}>
          <img src={userIcon} style={{ height: "2.7vh", paddingBottom: "0.3em", paddingRight: "0.5vw" }} />
          <span style={{ paddingRight: "1vw", fontWeight: 500, fontSize: "1.25em", color: "#0F0718", marginBottom: 0 }}>{userData?.user}</span>
          <img src={Calender} style={{ height: "3.5vh", paddingRight: "0.5vw", paddingBottom: "0.3em" }} />
          <span style={{ fontSize: "1.25em", color: "#929098", fontWeight: "500" }}>{currentDateTime}</span>
        </Col>
      </Row>

      <div style={{ flex: 1 }}>
        {cashInData.length > 0 && (
          <Row gutter={[16, 16]} style={{ paddingTop: "2vh" }}>
            {cashInData.map((recordData, idx) => (
              <Col span={8} key={idx}>
                <Card style={{ height: "14vh", width: "100%", borderRadius: "10px", padding: "2vh 1.3vw", fontSize: "1vw" }}>
                  <Space style={{ width: "100%", justifyContent: "space-between" }}>
                    <Text style={{ fontSize: "1.25em", fontWeight: "600", color: "#0F0718" }}>{recordData.note}</Text>
                    <Text style={{ fontSize: "1.25em", fontWeight: "600", color: "#0F0718" }}>{recordData.type}</Text>
                  </Space>
                  <Space style={{ width: "100%", justifyContent: "space-between", paddingTop: "2vh" }}>
                    <Text style={{ fontSize: "1em", fontWeight: "500", color: "#0F0718" }}>{recordData.date}</Text>
                    <Text style={{ fontSize: "1.25em", fontWeight: "600", color: "#0F0718" }}>{recordData.amount}</Text>
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {cashInData.length <= 0 && (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "70vh" }}>
            <img src={CashGif} alt="Cash Drawer Animation" style={{ width: "150px", height: "auto", marginBottom: "2vh" }} />
            <div style={{ marginBottom: "3vh", fontSize: "1vw", fontWeight: "600", color: "#0F0718", textAlign: "center" }}>
              {getMultilingualText("Add or Remove Cash from the Cash Drawer")}
            </div>
            {actionButtons}
          </div>
        )}
      </div>

      {cashInData.length > 0 && (
        <div style={{ position: "absolute", bottom: "20px", right: "20px", display: "flex", gap: "12px" }}>
          {actionButtons}
        </div>
      )}
    </div>
  );
};

export default CashManagement;
